<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CbH4SU/tc-custom/9781683350781.jpg?1700958214929" alt="This image is the cover for the book Face Like Glass"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Face Like Glass
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An amnesiac girl explores an enchanting underground world filled with sinister secrets in this YA fantasy from the award-winning author of <i>The Lie Tree</i>.</b><br/><br/> In the underground city of Caverna, the world’s most skilled craftspeople toil in the darkness to create delicacies beyond compare—wines that remove memories, cheeses that make you hallucinate, and perfumes that convince you to trust the wearer, even as he slits your throat. On the surface, the people of Caverna seem ordinary, except for one thing: their faces are as blank as untouched snow. Expressions must be learned, and only the famous Facesmiths can teach a person to express (or fake) joy, despair, or fear—at a steep price. Into this dark and distrustful world comes Neverfell, a girl with no memory of her past and a face so terrifying to those around her that she must always wear a mask. Neverfell’s expressions are as varied and dynamic as those of the most skilled Facesmiths, except hers are entirely genuine. And that makes her very dangerous indeed . . .<br/><br/><b>Praise for <i>A Face Like Glass</i><br/> An ALA/ALSC Notable Children’s Book<br/><br/> “Hardinge is at the top of her game with this entrancing and action-packed adventure. Her voluptuous prose is full of sensory details and wildly imaginative descriptions, yet the world-building is controlled and gradually revealed. . . . VERDICT A compelling and triumphant follow-up to <i>The Lie Tree</i> for those who love to become immersed in a good story.” —<i>School Library Journal</i>, starred review<br/><br/> “Using beautiful prose, Hardinge builds a richly imagined world that twists as much as the carefully orchestrated plot. Readers will eagerly follow noble Neverfell through its tunnels, marveling at the extraordinary sights and catching their breath at her daring escapades.” ―<i>Booklist</i>, starred review<br/><br/> “Hardinge excels at wordplay and worldbuilding; witty but not trite, her utterly original setting and chaotic, fidgety protagonist anchor a cracking good story that raises important ideas surrounding the nature of friendship, the value of honesty, and the danger of too much.” ―<i>Kirkus Reviews</i>, starred review</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frances Hardinge
      </h2>
      
      <p class="authorDescription body article">Frances Hardinge is the winner of the 2015 Costa Book of the Year for The Lie Tree, one of just two young adult novels to win this major UK literary prize. She is the author of several books for children, including Cuckoo Song, The Lost Conspiracy, Fly By Night, Well Witched, and Fly Trap. She lives in England. www.franceshardinge.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Amulet Books New York
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d9bd38b6